/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import t from 'prop-types';

var BotonPDF = function BotonPDF(_ref) {
  var fichero = _ref.fichero,
      clase = _ref.clase,
      texto = _ref.texto;

  if (window.electronContext && window.mostrarPDF) {
    // si estamos en electron y existe la función mostrarPDF en index.html
    return React.createElement('a', {
      onClick: function onClick() {
        return window.mostrarPDF(fichero);
      },
      rel: 'noopener noreferrer',
      className: clase
    }, texto);
  } else if (window.parent.electronContext && window.parent.mostrarPDF) {
    // si estamos en electron, index.html está cargado en un i-frame y existe la función mostrarPDF en el fichero de carga
    return React.createElement('a', {
      onClick: function onClick() {
        return window.parent.mostrarPDF(fichero);
      },
      rel: 'noopener noreferrer',
      className: clase
    }, texto);
  } else if (window.electronContext && !window.mostrarPDF) {
    // si estamos en electron y NO existe la función mostrarPDF en index.html
    return React.createElement('a', {
      href: fichero,
      rel: 'noopener noreferrer',
      className: clase
    }, texto);
  } else {
    // --> navegador
    return React.createElement('a', {
      href: fichero,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: clase
    }, texto);
  }
};

BotonPDF.propTypes = process.env.NODE_ENV !== "production" ? {
  fichero: t.string,
  clase: t.string,
  texto: t.string.isRequired
} : {};
export default BotonPDF;